import type {
    LoadingDotsLayerRangesConstantType,
    LoadingDotsCellsConstantType,
    LoadingDotsLayerRanges,
    LoadingDotsCell
} from "./type";
import {
    LOADING_DOTS_PATTERNS,
    LOADING_DOTS_MOTIONS
} from "./constant";

export const getLoadingDotsCells = ({
    pattern
}: LoadingDotsCellsConstantType): Array<LoadingDotsCell> => {
    const spec = LOADING_DOTS_PATTERNS[pattern];

    return spec.steps.map((step) => {
        if(step === null) {
            return {
                isLead: false,
                offset: null
            };
        }

        return {
            offset: step / spec.period,
            isLead: step === 0
        };
    });
};

export const getLoadingDotsLayerRanges = ({
    motion
}: LoadingDotsLayerRangesConstantType): LoadingDotsLayerRanges => {
    const {
        stops
    } = LOADING_DOTS_MOTIONS[motion];

    return {
        darkRange: stops.map((stop) => stop.tone === "dark" ? 1 : 0),
        midRange: stops.map((stop) => stop.tone === "dim" ? 0 : 1),
        inputRange: stops.map((stop) => stop.at)
    };
};
